module.exports = __webpack_public_path__ + "static/media/brocolis.52f75940.svg";